module.exports = __webpack_public_path__ + "img/12-who-gets-to-stay.d3a803a7.jpg";